import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./assets/reset.scss";
import "./assets/global.scss";
import "./assets/kits/colors/colors.css";

import "./assets/kits/margin-padding.css";
import "./assets/kits/fontSize.css";
// layout style
import "./components/layout/Layout.scss";
import "./components/layout/VendorLayout/VendorLayout.scss";
//BottomNavigation styles
import "./components/kits/bottomNavigation/BottomNavigation.scss";

// common components
import "./components/common/ProductCard/product-card.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
